import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
    return (
      <div className="text-xl font-semibold bg-slate-100 h-[60px] flex-wrap  flex justify-center items-center">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? "text-red-400 ml-6 " : "text-black ml-6"
          }
        >
          HOME
        </NavLink>
        <NavLink
          to="/reviews"
          className={({ isActive }) =>
            isActive ? "text-red-400 ml-6" : "text-black ml-6"
          }
        >
          REVIEWS
        </NavLink>
        <NavLink
          to="/dashBoard"
          className={({ isActive }) =>
            isActive ? "text-red-400 ml-6" : "text-black ml-6"
          }
        >
          DASHBOARD
        </NavLink>
        <NavLink
          to="/blogs"
          className={({ isActive }) =>
            isActive ? "text-red-400 ml-6 " : "text-black ml-6"
          }
        >
          BLOGS
        </NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive ? "text-red-400 ml-6" : "text-black ml-6"
          }
        >
          ABOUT
        </NavLink>
      </div>
    );
};

export default Header;